import { apiErrorMessage } from "../../services/apiError";

// CayenneLPP is not a catalog entry: its channels come from each payload.
export const CAYENNE_SUPPORTED_TYPES = [
  "digital_sensor",
  "analog_sensor",
  "luminosity",
  "presence",
  "temperature",
  "relative_humidity",
  "accelerometer",
  "barometric_pressure",
  "gyrometer",
  "gps",
];

// Humanized labels for type slugs. Anything not in this map is rendered as the
// raw slug (acceptable fallback for types we haven't humanized yet).
export const TYPE_LABELS = {
  digital_sensor: "Digital sensor",
  analog_sensor: "Analog sensor",
  luminosity: "Luminosity",
  presence: "Presence",
  temperature: "Temperature",
  relative_humidity: "Humidity",
  accelerometer: "Accelerometer",
  barometric_pressure: "Barometric pressure",
  gyrometer: "Gyrometer",
  gps: "GPS",
  battery: "Battery",
  soil_conductivity: "Soil conductivity",
};

export const labelFor = (slug) => TYPE_LABELS[slug] || slug;

// Decoder types that are not catalog entries.
export const FIXED_DECODERS = [
  { id: "cayennelpp", label: "CayenneLPP" },
  { id: "custom", label: "Custom" },
];

export const catalogLabel = (entry) => `${entry.make} ${entry.model}`;

export const decoderLabel = (type, entries = []) => {
  const entry = entries.find((e) => e.id === type);
  if (entry) return catalogLabel(entry);
  const fixed = FIXED_DECODERS.find((d) => d.id === type);
  return fixed ? fixed.label : type;
};

// A user holds one profile per catalog model; the API answers a second with 409.
export const decoderTypeError = (err) => {
  const body = err && err.error;
  if (body && typeof body === "object" && body.code === "catalog_profile_exists") {
    return { conflict: true, profileId: body.profile || null, message: body.message || "" };
  }
  return { conflict: false, profileId: null, message: apiErrorMessage(err, "Failed to update decoder type") };
};
